import { Data, useUIActions } from "../../../../../features/ui"
import { define } from "../../../../../utils/typeUtils"
import { TaxCategory } from "../../../../operations"
import { useSupplierActions } from "../../../actions/supplierActions"
import { Supplier } from "../../../state/types"

export const useActions = () => {
    const { saveSupplier } = useSupplierActions()
    const { onSubmitDataType } = useUIActions()

    const submitSupplier = async (
        supplierData: Data,
        code: number,
        productSupplier: boolean
    ) => {
        const { companyId, id, name, taxId, taxCategory } = supplierData
        const supplier: Supplier = {
            companyId: companyId as string,
            id: id as string,
            code,
            name: define(name) as string,
            taxId: define(taxId) as number,
            taxCategory: define(taxCategory) as TaxCategory,
            productSupplier
        }
        
        const savedSupplier = await saveSupplier(supplier)
        onSubmitDataType(true, false)
        
        return savedSupplier
    }
    
    return {
        submitSupplier
    }
}
